import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  createLegalEntityName,
  updateLegalEntityName,
} from '../store/actions/person/personActions';
import useApplicationUid from './useApplicationUid';

const useBusinessNameDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const businessNameDispatch = ({
    data,
    ApplicantData,
    defaultValues,
    onSuccess,
  }) => {
    const shouldSkip =
      isEqual(data, defaultValues) && data?.BusinessName !== '';

    if (shouldSkip) {
      onSuccess();
      return;
    }

    const requestData = {
      ApplicationUid,
      data: {
        Name: data?.BusinessName === '' ? null : data?.BusinessName,
      },
      onSuccess,
    };

    if (ApplicantData && defaultValues) {
      dispatch(
        updateLegalEntityName({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createLegalEntityName({
        ...requestData,
      }),
    );
  };

  return { businessNameDispatch };
};

export default useBusinessNameDispatch;
